import { render, staticRenderFns } from "./PromotionSet.vue?vue&type=template&id=579dbbae&scoped=true&"
import script from "./PromotionSet.vue?vue&type=script&lang=js&"
export * from "./PromotionSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579dbbae",
  null
  
)

export default component.exports